import React, { useState, useEffect } from 'react';
import { Sparkles, FileSearch } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const WelcomeSplash = () => {
  const { user } = useAuth();
  const [type, setType] = useState(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const flag = sessionStorage.getItem('riq_welcome');
    if (flag && user) {
      sessionStorage.removeItem('riq_welcome');
      setType(flag);
      const fadeTimer = setTimeout(() => setLeaving(true), 2600);
      const closeTimer = setTimeout(() => setType(null), 3000);
      return () => { clearTimeout(fadeTimer); clearTimeout(closeTimer); };
    }
  }, [user]);

  if (!type || !user) return null;

  const firstName = (user.name || '').split(' ')[0];
  const isNew = type === 'new';

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center pointer-events-none transition-opacity duration-400 ${leaving ? 'opacity-0' : 'opacity-100'}`}
      style={{ transition: 'opacity 0.4s ease' }}
    >
      <div
        data-testid={isNew ? 'welcome-new-popup' : 'welcome-back-popup'}
        className="bg-slate-900/95 backdrop-blur-xl border border-slate-700/60 rounded-2xl px-10 py-8 shadow-2xl shadow-blue-500/20 text-center max-w-sm mx-4"
        style={{ animation: 'riqWelcomeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1)' }}
      >
        <img src="/images/triq-logo.png" alt="TRIQ - The Recruiter IQ" className="w-14 h-14 mx-auto mb-4 rounded-full object-contain" />
        <h2 className="text-2xl font-bold text-white">
          {isNew ? (
            <>Welcome to <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">RecruiterIQ</span>! 🎉</>
          ) : (
            <>Welcome back{firstName ? `, ${firstName}` : ''}! 👋</>
          )}
        </h2>
        <p className="text-sm text-slate-400 mt-2">
          {isNew ? 'Your TA community & toolkit awaits.' : 'Great to see you again.'}
        </p>
      </div>
      <style>{`
        @keyframes riqWelcomeIn {
          from { opacity: 0; transform: scale(0.9) translateY(12px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};
